<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	import { companyCapacityTypes } from "../config";

	export let name;
	export let capacity;
	export let acnAbn;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<h3>Company Details</h3>

<FormRow>
	<FormColumn cols="4">
		<label for="name" class:isrequired={required}>Company Name</label>
		<input {required} {disabled} maxlength="1000" type="text" bind:value={name} id="name" class="form-control" />
	</FormColumn>
	<FormColumn cols="4">
		<label for="acnAbn">ABN/ACN</label>
		<input {disabled} maxlength="20" type="text" bind:value={acnAbn} id="acnAbn" class="form-control" />
	</FormColumn>
	<FormColumn cols="4">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={companyCapacityTypes}
			textProperty="name"
			valueProperty="name"
		></Select>
	</FormColumn>
</FormRow>
<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to register on behalf of the company"
			{required}
			id="authc"
		></Checkbox>
	</FormColumn>
</FormRow>
